import "./style.css"
import React  from "react";
import {Spin} from 'antd';

const LoadingPage = () => {
    return <div className="loadingPage">
        <Spin size="large" />
    </div>
}

export default LoadingPage
